import { Filter } from "../services/swagger";

export function prepareFilterString(filters: Filter[]): string {
  return JSON.stringify(filters);
}

export function getRegex(str: string): RegExp {
  let newStr = str.replace(/[iIİı]/g, "[iİı]");
  newStr = newStr.replace(/[oOöÖ]/g, "[oö]");
  newStr = newStr.replace(/[cCçÇ]/g, "[cç]");
  newStr = newStr.replace(/[sSşŞ]/g, "[sş]");
  newStr = newStr.replace(/[uUüÜ]/g, "[uü]");
  newStr = newStr.replace(/[gGğĞ]/g, "[gğ]");
  return new RegExp(newStr, "i");
}
